// extracted by mini-css-extract-plugin
module.exports = {"change-language-modal":"ChangeLanguageModal_change-language-modal__2oQk_","country-picker-wrapper":"ChangeLanguageModal_country-picker-wrapper__mezBf"};